import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '@/services/auth.service';

/**
 * Guard to protect routes that require authentication
 */
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  // Redirect to login with return URL
  router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  return false;
};

/**
 * Guard to protect admin routes
 */
export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const currentUser = authService.getCurrentUser();

  if (currentUser && currentUser.role === 'admin') {
    return true;
  }

  // Redirect to appropriate page
  router.navigate(['/portal']);
  return false;
};

/**
 * Guard to protect candidate routes
 */
export const candidateGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const currentUser = authService.getCurrentUser();

  if (currentUser && currentUser.role === 'candidate') {
    return true;
  }

  // Redirect to appropriate page
  router.navigate(['/portal']);
  return false;
};

/**
 * Guard to protect evaluator routes
 */
export const evaluatorGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const currentUser = authService.getCurrentUser();

  if (currentUser && currentUser.role === 'evaluator') {
    return true;
  }

  // Redirect to appropriate page
  router.navigate(['/portal']);
  return false;
};

/**
 * Guard to protect supervisor routes
 */
export const supervisorGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const currentUser = authService.getCurrentUser();

  if (currentUser && currentUser.role === 'supervisor') {
    return true;
  }

  // Redirect to appropriate page
  router.navigate(['/portal']);
  return false;
};
